import { jsx as _jsx } from "react/jsx-runtime";
import { Children, useLayoutEffect, useMemo, useState } from 'react';
import styled from 'connect-dot-com-ui/components/Theme';
const GRID_GAP_LARGE = '32px';
const GRID_GAP_SMALL = '12px';
const Grid = styled.div.withConfig({
  displayName: "MasonryGrid__Grid",
  componentId: "sc-1c2ncph-0"
})(["display:grid;grid-gap:", ";grid-template-columns:repeat(auto-fill,minmax(250px,1fr));@media (max-width:", "){grid-gap:", ";grid-auto-rows:unset;}"], GRID_GAP_LARGE, props => props.theme.sizes.GRID_BREAKPOINT_SMALL, GRID_GAP_SMALL);
const GridItem = styled.div.withConfig({
  displayName: "MasonryGrid__GridItem",
  componentId: "sc-1c2ncph-1"
})(["margin-bottom:", ";@media (max-width:", "){margin-bottom:", ";}"], GRID_GAP_LARGE, props => props.theme.sizes.GRID_BREAKPOINT_SMALL, GRID_GAP_SMALL);

const MasonryGrid = ({
  children
}) => {
  const [gridEl, setGridEl] = useState(null);
  const [numColumns, setNumColumns] = useState(0);
  useLayoutEffect(() => {
    if (gridEl) {
      const handleSetNumColumns = () => {
        const currentNumColumns = window.getComputedStyle(gridEl).getPropertyValue('grid-template-columns').split(' ').length;

        if (numColumns !== currentNumColumns) {
          setNumColumns(currentNumColumns);
        }
      };

      handleSetNumColumns();
      window.addEventListener('resize', handleSetNumColumns);
      return () => {
        window.removeEventListener('resize', handleSetNumColumns);
      };
    }

    return () => {};
  }, [gridEl, numColumns]);
  const gridColumns = useMemo(() => {
    const columns = Array.from({
      length: numColumns
    }, __ => []);

    if (numColumns) {
      Children.forEach(children, (child, index) => {
        columns[index % numColumns].push( /*#__PURE__*/_jsx(GridItem, {
          children: child
        }, index));
      });
    }

    return columns;
  }, [numColumns, children]);
  return /*#__PURE__*/_jsx(Grid, {
    ref: setGridEl,
    children: gridColumns.map((column, index) => /*#__PURE__*/_jsx("div", {
      children: column
    }, index))
  });
};

export default MasonryGrid;